import React, { useEffect } from 'react';
import PageLayout from 'components/layouts/PageLayout';
import LocalizeInput from 'components/input/LocalizeInput';
import { useStateContext } from 'providers/usePageState';
import Button from 'components/input/Button';
import { useModelStateContext } from 'saladsoft-primitive';
import { AdminListingDto, AdminListingRequestDto } from 'services/data-contracts';

import { saveListing } from 'controllers/listingsController';
import ButtonWrapper from 'components/pages/listings/ButtonWrapper';
import { InnerGroup, InnerSection } from 'components/layouts/CommonForm';
import Text from 'components/commons/Text';
import Link from '@mui/material/Link';

const NamePage = () => {
  const { listing, setListing } = useStateContext();
  const { updateServiceModel, serviceModel, updateServiceModelMultiple } =
    useModelStateContext<AdminListingRequestDto>();

  const handleSave = async () => {
    if (serviceModel.current) {
      const newListing = (await saveListing(serviceModel.current)) as AdminListingDto;
      setListing(newListing);
    }
  };

  useEffect(() => {
    if (listing) {
      updateServiceModelMultiple(listing);
    }
  }, [listing]);

  return (
    <PageLayout title="숙소명">
      {listing && (
        <>
          <InnerSection style={{ minHeight: 'unset' }}>
            <InnerGroup>
              <div>
                <Text type="H3">숙소명</Text>
                <Text type="H4" buttonRole="DESCRIPTION" style={{ margin: '10px 0' }}>
                  숙소명을 입력해주세요.
                  <br />
                  언어 변경은 아래의 링크에서 설정이 가능합니다.
                </Text>
                <Link style={{ fontSize: 14 }} href="/admin/settings/language-settings">
                  언어설정
                </Link>
              </div>
              <LocalizeInput
                label="숙소명"
                defaultValue={listing?.localizedName}
                onChange={(value) => updateServiceModel('localizedName', value)}
              />
            </InnerGroup>
          </InnerSection>
          <InnerSection style={{ minHeight: 'unset' }}>
            <InnerGroup>
              <div>
                <Text type="H3">숙소 소개</Text>
                <Text type="H4" buttonRole="DESCRIPTION" style={{ margin: '10px 0' }}>
                  시설을 잘 표현할 수 있는 한줄 소개를 입력해 주세요.
                </Text>
              </div>
              <LocalizeInput
                label="숙소명"
                defaultValue={listing?.localizedTitle}
                onChange={(value) => updateServiceModel('localizedTitle', value)}
              />
            </InnerGroup>
          </InnerSection>
        </>
      )}

      <ButtonWrapper>
        <Button style={{ minHeight: 25, width: 100 }} onClick={handleSave}>
          저장
        </Button>
      </ButtonWrapper>
    </PageLayout>
  );
};

export default NamePage;
